export default "//static.tradera.net/touchweb/static/output/images/google-pay.5a4d9214.svg";